import React, { useState } from 'react';

import { faUserCircle, faQuestionCircle, faThLarge } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Dropdown, Menu } from 'antd';

import { logout, getEmailLogged } from '~/auth';
import { Box } from '~/components';
import ModalRDStation from '~/components/ModalRDStation';

import { aberturaTicketNovo, gestaoTicketNovo } from './actions';
import S from './styles';

const logo = 'https://images.e-auditoria.com.br/global/logos/svg/gestao.svg';

function Header() {
  const [visivel, setVisivel] = useState(false);

  const listaProdutos = [
    { key: 'eAuditor', nome: 'e-Auditor', isConta: false },
    { key: 'eSimulador', nome: 'e-Simulador', isConta: false },
    { key: 'eConsulta', nome: 'e-Consulta', isConta: false },
    { key: 'eDrive', nome: 'e-Drive', isConta: false },
    { key: 'eCapturador', nome: 'e-Capturador', isConta: true },
    { key: 'eAtendimento', nome: 'e-Atendimento', isConta: true },
    { key: 'eRecuperador', nome: 'e-Recuperador', isConta: false },
    { key: 'eMonitor', nome: 'e-Monitor', isConta: false },
  ];

  const logoProduto = (nome) =>
    `https://images.e-auditoria.com.br/global/logos/svg/${nome.toLowerCase()}-mini.svg`;

  const handleSolicitarUpgrade = () => {
    setVisivel(true);
  };

  const produtos = (
    <Box title="Produtos">
      <S.Products>
        {listaProdutos.map((item) => (
          <S.Products.Item
            key={item.key}
            onClick={() => {
              if (item.isConta) {
                window.open(`https://conta.e-auditoria.com.br/${item.key}`, '_self');
              } else {
                window.open(`https://${item.key}.e-auditoria.com.br`, '_self');
              }
            }}
          >
            <S.Products.Imagem src={logoProduto(item.key)} alt={item.nome} />
            <span>{item.nome}</span>
          </S.Products.Item>
        ))}
      </S.Products>
    </Box>
  );

  const atendimento = (
    <Box title="e-Atendimento">
      <Menu className="condensed">
        <Menu.Item>
          <a onClick={aberturaTicketNovo}>Abertura de ticket</a>
        </Menu.Item>
        <Menu.Item>
          <a onClick={gestaoTicketNovo}>Gestão de tickets</a>
        </Menu.Item>
        <Menu.Item>
          <a onClick={handleSolicitarUpgrade}>Solicitar upgrade</a>
        </Menu.Item>
        <Menu.Item>
          <a target="_blank" rel="noopener noreferrer" href="http://e-auditoria.com.br/faq/">
            FAQ
          </a>
        </Menu.Item>
        <Menu.Item>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://conta.e-auditoria.com.br/Home/Manual"
          >
            Manual
          </a>
        </Menu.Item>
        <Menu.Item>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="http://www.e-auditoria.com.br/materiais-educacionais/"
          >
            Materiais Educacionais
          </a>
        </Menu.Item>
        <Menu.Item>
          <a target="_blank" rel="noopener noreferrer" href="https://convenios.e-auditoria.com.br/">
            Convênios e Benefícios
          </a>
        </Menu.Item>
      </Menu>
    </Box>
  );

  const usuario = (
    <Box>
      <S.User>
        <S.User.Content direction="vertical" align="center">
          <FontAwesomeIcon icon={faUserCircle} size="3x" />
          <S.User.Email>{getEmailLogged()}</S.User.Email>
          <Button
            size="small"
            onClick={() => window.open('https://conta.e-auditoria.com.br/Perfil')}
          >
            Gerenciar a sua Conta
          </Button>
        </S.User.Content>

        <Button size="small" onClick={() => logout()}>
          Sair da Conta
        </Button>
      </S.User>
    </Box>
  );

  return (
    <S.Header>
      <S.Brand onClick={() => window.open('https://erecuperador.e-auditoria.com.br', '_self')}>
        <S.Brand.Image src={logo} alt="Gestão de Propostas e Contratos" />
      </S.Brand>

      <S.Navbar>
        <Dropdown overlay={produtos} trigger={['click']}>
          <FontAwesomeIcon icon={faThLarge} size="2x" cursor="pointer" color="#bebebe" />
        </Dropdown>

        <Dropdown overlay={atendimento} trigger={['click']}>
          <FontAwesomeIcon
            icon={faQuestionCircle}
            size="2x"
            cursor="pointer"
            color="#bebebe"
            style={{ margin: '0 1.25rem' }}
          />
        </Dropdown>

        <Dropdown overlay={usuario} trigger={['click']}>
          <FontAwesomeIcon icon={faUserCircle} size="2x" cursor="pointer" color="#bebebe" />
        </Dropdown>
      </S.Navbar>

      <ModalRDStation
        titulo="Descubra como a nova e-Auditoria pode transformar seu escritório"
        visivel={visivel}
        setVisivel={setVisivel}
      />
    </S.Header>
  );
}

export default Header;
